/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OrgAuthorizationTenantSpec { 
    /**
     * If true - it will re-authorize a tenant org. Else it will re-authorize on the need basis and will be a no-op otherwise.
     */
    force_create?: boolean;
}

